import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';

@Injectable()
export class OneTimeTokenResolver implements Resolve<string | null | RedirectCommand> {
  oneTimeToken: string | null = null;

  resolve() {
    return this.oneTimeToken;
  }
}
